import { availableCash, cashAfterDebits } from "../../../../shared/financeCash.ts";
import type { CashAccount } from "../../../../shared/financeCash.ts";

interface ForecastDue {
  iso: string;
  source: string;
  amount: number;
  funding?: "debit" | "credit";
}

export function buildCashForecast(
  accounts: readonly CashAccount[],
  incomes: readonly ForecastDue[],
  expenses: readonly ForecastDue[],
  repayments: readonly ForecastDue[],
  horizonIso: string,
) {
  const startCash = availableCash(accounts);
  // The API has already removed paid occurrences. Credit purchases remain in
  // the obligations list, while only debit costs and repayments leave cash.
  const landings = [
    ...incomes.map((row) => ({ iso: row.iso, label: row.source, amount: row.amount, kind: "in" as const })),
    ...expenses.filter((row) => row.funding !== "credit").map((row) => ({ iso: row.iso, label: row.source, amount: -row.amount, kind: "bill" as const })),
    ...repayments.map((row) => ({ iso: row.iso, label: row.source, amount: -row.amount, kind: "debt" as const })),
  ].filter((row) => row.iso && row.iso <= horizonIso)
    .sort((a, b) => a.iso.localeCompare(b.iso) || a.amount - b.amount);
  let cash = startCash;
  const ledger = landings.map((row) => ({ ...row, after: (cash = cashAfterDebits(cash, -row.amount)) }));
  return { startCash, ledger };
}
